"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIAssistDOMHelper = void 0;
/**
 * Static helper class for DOM manipulation and UI operations
 */
class AIAssistDOMHelper {
    /**
     * Scroll to bottom of entry list
     */
    static scrollToBottom(shadowRoot) {
        if (!shadowRoot)
            return;
        const entryList = shadowRoot.querySelector('.entry-list');
        if (entryList) {
            entryList.scrollTop = entryList.scrollHeight;
        }
    }
    /**
     * Ensure scroll to bottom with animation frame
     */
    static ensureScrollToBottom(shadowRoot) {
        requestAnimationFrame(() => {
            AIAssistDOMHelper.scrollToBottom(shadowRoot);
        });
    }
    /**
     * Toggle minimized class on host element
     */
    static toggleMinimizedClass(shadowRoot, isMinimized) {
        if (!(shadowRoot === null || shadowRoot === void 0 ? void 0 : shadowRoot.host))
            return;
        if (isMinimized) {
            shadowRoot.host.classList.add('minimized');
        }
        else {
            shadowRoot.host.classList.remove('minimized');
        }
    }
    /**
     * Bind input event listeners
     */
    static bindInputEvents(input, onInputChange) {
        input.addEventListener('keyup', onInputChange);
    }
}
exports.AIAssistDOMHelper = AIAssistDOMHelper;
